import { useEffect } from "react";

export default function Rewardful() {
  useEffect(() => {
    (function (w, r) {
      w._rwq = r;
      w[r] =
        w[r] ||
        function () {
          (w[r].q = w[r].q || []).push(arguments);
        };
    })(window, "rewardful");

    let s = document.createElement("script");
    s.async = true;
    s.src = "https://r.wdfl.co/rw.js";
    s.setAttribute("data-rewardful", "d2d432");
    document.head.appendChild(s);
  }, []);

  return null;
}
